import React, { Component } from 'react'
import { connect } from 'react-redux'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import autobind from 'autobind-decorator'
import "whatwg-fetch"

import MyLinkListItem from "./MyLinkListItem"
import MyLinkDragLayer from "./MyLinkDragLayer";
import MyLinkAddForm from "./MyLinkAddForm"

import { receiveLink, changeSaveStatus, afterSave } from '../../actions/mylink'
import { jsonResponseHandler } from "../../utils/FetchHelper"
import * as SaveStatus from '../../constants/SaveStatus'
import TSubmitButtonForm from "../common/TSubmitButtonForm";
import {addPrefix} from "../../utils/UriUtil";

@connect(state => ({
	links: state.link.my.links,
	saveStatus: state.link.my.saveStatus
}), dispatch => ({
	handleReceiveMyLink(data) {
		dispatch(receiveLink(data))
	},
	handleChangeSaveStatus(saveStatus) {
		dispatch(changeSaveStatus(saveStatus))
	},
	handleAfterSave() {
		dispatch(afterSave())
	},
    dispatch
}))
class MyLinkList extends Component {

	constructor(props, context) {
		super(props, context)
		this.state = {
			editLinkId: null
		}
	}

	@autobind
	handleSave() {
		const { handleChangeSaveStatus, handleAfterSave, saveStatus, links, dispatch } = this.props

		handleChangeSaveStatus(SaveStatus.DOING)
		fetch(addPrefix("/manage/link/my/ordering.json"), {
			method: "post",
			credentials: "include",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				ordering: links.map(item => item.linkId)
			})
		})
			.then(jsonResponseHandler(dispatch))
			.then(() => {
				handleAfterSave()
			})
			.catch(e => {
				console.error(e)
				handleChangeSaveStatus(saveStatus)
			})
	}

	@autobind
	handleEdit(linkId) {
		this.setState({
			editLinkId: linkId
		})
	}

	render() {
		const { links, saveStatus } = this.props
		const { editLinkId } = this.state

		return (
		  <DndProvider backend={HTML5Backend}>
        <div className="wrap_set">
          <div className="desc_mylink">
            <p className="tit_mylink">자주 찾는 사이트를 링크에 추가해 블로그에 표시할 수 있습니다.
              <span className="count_total">
                        <span className="screen_out">링크 개수</span>
                        <span className="txt_num">{links.length}</span> / 100
                    </span>
            </p>
            <p className="txt_mylink">드래그 앤 드롭으로 위치를 조절할 수 있습니다.</p>
          </div>
          <div className="set_order">
            <div className="wrap_order">
              <strong className="screen_out">링크한 사이트 목록</strong>
              <div className="list_order type_thumb">
                { links.map((item, index) =>
                  <MyLinkListItem key={index} index={index} item={item} editLinkId={editLinkId} onEdit={this.handleEdit} />
                )}
                <MyLinkDragLayer />
              </div>

            </div>

            <MyLinkAddForm />

          </div>
          <div className="set_btn">
            <TSubmitButtonForm status={saveStatus} onClick={this.handleSave}/>
          </div>
        </div>
      </DndProvider>
		)
	}
}

export default MyLinkList
